<template>
  <div id="#app" class="app">
    <!--轮播图-->
    <div class="Rotary" style="margin-top:86px">
      <div id="myCarousel" class="carousel slide">
        <ol class="carousel-indicators">
          <li data-target="#myCarousel" data-slide-to="0" class="active spanMore"></li>
          <li data-target="#myCarousel" data-slide-to="1" class="spanMore"></li>
          <li data-target="#myCarousel" data-slide-to="2" class="spanMore"></li>
        </ol>
        <!-- Carousel items -->
        <div style="width: 1920px;height:780px;overflow:hidden" class="carousel-inner">
          <div
            v-for="(itemimg,index) in RotaryImg"
            :class="index == 0 ? 'active' : ''"
            class="item"
            :key="index"
          >
            <img :src="itemimg.url+'?x-oss-process=image/resize,w_1920'" alt>
          </div>
        </div>
        <!-- Carousel nav -->
        <a class="navS carousel-control left" href="#myCarousel" data-slide="prev">
          <img src="../assets/nav.svg" alt>
        </a>
        <a class="navS carousel-control right" href="#myCarousel" data-slide="next">
          <img src="../assets/nav.svg" alt>
        </a>
      </div>
    </div>
    <!--轮播图-->
    <!--产品展示-->
    <div class="product">
      <div class="productText">
        <div>{{$t('data.headText.pageOne.pageText.Product')}}</div>
        <div>
          <span v-for="(item,index) in productText" :key="index">
            <span
              @click="procl(item,index)"
              style="cursor: pointer"
              :style="proindex==item.id ? 'color:#57C6EB':''"
            >{{item.title}}</span>
            <span v-if="index!=2">|</span>
          </span>
        </div>
      </div>
      <div class="productTexts">Products</div>
      <div>
        <div class="productImg" id="probox">
          <div
            v-for="(item,index,i) in prolist[proindex]"
            :key="index"
            @click="details(index)"
            v-if="i<10"
          >
            <img :src="item+'?x-oss-process=image/resize,h_1000'" style="width:210PX">
          </div>
        </div>
        <div class="MoreDiv">
          <button class="btn btn-large MoreBtn" type="button" @click="tointe">
            <a>More</a>
          </button>
        </div>
        <div></div>
      </div>
    </div>
    <!--品牌介绍-->
    <!-- <div class="introduceAll">
      <div class="introduceOne">
        <div class="introduceText">
          {{$t('data.headText.pageOne.pageText.introduce.patent')}}
        </div>
      </div>
      <div class="introduceTwo">
        <img src="../assets/1101.png" alt="">
      </div>
      <div class="introduceThree">aaaa
        <p> {{$t('data.headText.pageOne.pageText.introduce.brief')}}</p>
        <p>BRAND INTRODUCTION</p>
      </div>
    </div>-->
    <div class="introduceAll">
      <div class="introducebox" v-for="(item,index,i) in productText" :key="i">
        <img :src="item.img+'?x-oss-process=image/resize,w_1020'" alt>
        <div class="clatitle">
          <div>
            <h2 class="clatit">VVC{{item.title}}</h2>
            <p class="clacontent">{{item.content}}</p>
            <p
              class="more"
              @click="tointegration(item,index)"
            >{{$t('data.headText.viewmore.title')}}</p>
          </div>
        </div>
      </div>
    </div>
    <!--品牌介绍-->
    <!--品牌展示-->
    <div class="Exhibition">
      <div class="ExhibitionImg">
        <div
          :class="EImgShow == index++ ? 'EImgChange': ' '"
          v-if="index<4"
          v-for="(item,index) in proqieh"
          :key="index"
        >
          <img class="eimgchangeimg" :src="item.img+'?x-oss-process=image/resize,w_1020'" alt>
        </div>
      </div>
      <div class="ExhibitionNve">
        <span
          v-for="(item,index) in proqieh"
          :key="index"
          v-if="index<4"
          :class="EImgShow == index  ? 'ENveChange': ' '"
          @mouseenter="EImgChange(index)"
          @mouseleave="EImgChanges()"
        >0{{index+1}}</span>
        <!-- <span :class="EImgShow == 2  ? 'ENveChange': ' '" @mouseenter="EImgChange(2)" @mouseleave="EImgChanges()">02</span>
        <span :class="EImgShow == 3  ? 'ENveChange': ' '" @mouseenter="EImgChange(3)" @mouseleave="EImgChanges()">03</span>
        <span :class="EImgShow == 4  ? 'ENveChange': ' '" @mouseenter="EImgChange(4)" @mouseleave="EImgChanges()">04</span>-->
      </div>
    </div>
    <!--品牌展示-->
    <!--产品展示-->
    <!--品牌故事-->
    <div class="Story">
      <!-- <h1>{{$t('data.headText.pageOne.pageText.story.storyText')}}</h1>
      <p class="Storyp">Brand story</p>
      <div class="StoryMore">
        <div class="StoryDiv">
          <div><img src="../assets/1452533875233.png" alt=""></div>
          <p>{{$t('data.headText.pageOne.pageText.story.brand.idea')}}</p>
          <p>nternational expans</p>
        </div>
        <div class="StoryDiv">
          <div><img src="../assets/1452533882949.png" alt=""></div>
          <p>{{$t('data.headText.pageOne.pageText.story.brand.style')}}</p>
          <p>international expans cop</p>
        </div>
        <div class="StoryDiv">
          <div><img src="../assets/1452533890906.png" alt=""></div>
          <p>{{$t('data.headText.pageOne.pageText.story.brand.origin')}}</p>
          <p>international expans cop</p>
        </div>
      </div>-->
      <img src="../assets/story.jpg" alt style="width:100%;heigth:100%">
    </div>
    <!--品牌故事-->
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {
      EImgShow: -1,
      msg: null,
      RotaryImg: [],
      productText: [],
      prolist: {},
      proindex: 16,
      proid: null,
      prochildid: null,
      proqieh: null
    };
  },
  watch: {

  },
  mounted() {
    $("#tit span").click(function() {
      //var i = $('tit').index(this);//下标第二种写法
      $(this)
        .addClass("select")
        .siblings()
        .removeClass("select");
      $("#con li")
        .eq(i)
        .show()
        .siblings()
        .hide();
    });
  },
  created() {
    this.Rotary();
    // this.product(1)
    var muenall = JSON.parse(localStorage.getItem("muenall"));
    this.productText = muenall;
    var data = this.productText != null ? this.productText[0] : null;

    this.procl(data, 0);
    this.getprolist();
  },
  methods: {
    Rotary() {
      this.req
        .post("http://jd1.vvc.tw/index/index/getBannerAll", { status: 0 })
        .then(res => {
          this.RotaryImg = res.data.data;
        })
        .catch(err => {});
    },
    product(a) {
      // this.req.post('http://jd1.vvc.tw/index/goods/getMenuAll').then((res) => {
      //   this.productText = res.data.data
      //   this.procl(this.productText[0],0)
      // }).catch((err) => {
      // })
    },
    EImgChange(i) {
      this.EImgShow = i;
    },
    EImgChanges() {
      this.EImgShow = -1;
    },
    getprolist() {
      this.req
        .post("http://jd1.vvc.tw/index/goods/getGoodsHot", this.qs.stringify())
        .then(res => {
          if (res.data.code == 1) {
            this.prolist = res.data.data.goods_hot;
            this.proqieh = res.data.data.product_img;
          }
        });
    },
    procl(item, index) {
      if (!item) {
        return;
      }
      this.proindex = item.id;
      this.proid = index;
      this.prochildid = item.child[0].child[0].id;
    },
    details(index) {
      this.$router.push({
        path: "/doc",
        query: {
          id: index,
          index: this.proid
        }
      });
    },
    tointe() {
      this.$router.push({
        path: "/integration",
        query: {
          id: this.proid,
          bannerid: this.prochildid
        }
      });
    },
    tointegration(item, index) {
      this.$router.push({
        path: "/integration",
        query: {
          id: index,
          bannerid: item ? item.child[0].child[0].id : ""
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.app {
  width: 1920px;
  margin: 0 auto;
  padding-bottom: 143px;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.spanMore {
  margn-left: 30px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.252;
}

.carousel-inner {
  div img {
    margin: 0 auto;
  }
}

.left {
  left: 125px;
}

.right {
  right: 125px;
  transform: scaleX(-1);
}

.navS {
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.35;
  top: 49%;
  line-height: 58px;
}

.product {
  // margin 91px 146px 156px 118px
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;
}

.productText {
  // justify-content space-between
  // position relative
  height: 59px;

  div:nth-child(1) {
    padding-bottom: 8px;
    font-size: 36px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(74, 74, 74, 1);
    float: left;
  }

  div:nth-child(2) {
    font-size: 24px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(127, 127, 127, 0.46);
    line-height: 50px;
    float: right;
  }
}

.productTexts {
  font-size: 24px;
  display: flex;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(155, 155, 155, 1);
  padding-bottom: 40px;
  text-align: left;
  width: 100%;
}

.productImg {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  height: 750px;

  div {
    width: 210px;
    // height 310px
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-right: 36px;
    margin-bottom: 40px;
    text-align: center;
    box-sizing: border-box;
    background: #fff;
    cursor: pointer;

    img {
      width: 808px;
    }
  }
}

#probox div:nth-of-type(5n) {
  margin-right: 0;
}

.MoreDiv {
  text-align: center;
  margin-top: 14px;

  a {
    font-size: 20px;
    font-family: SFUIText-Light;
    font-weight: 300;
    color: rgba(155, 155, 155, 1);
  }
}

.MoreBtn {
  background: white;
  width: 293px;
  height: 60px;
  border: 1px solid rgba(215, 215, 215, 1);

  a {
    text-decoration: none;
  }
}

// .introduceOne
// width 941px
// height 338px
// background url("../assets/Rectangle.png")
// position absolute
// div
// white-space: wrap;
// overflow: hidden
// text-overflow: ellipsis;
// width: 494px;
// height: 241px;
// font-size: 20px;
// font-family: PingFang-SC-Regular;
// font-weight: 400;
// color: RGBA(125, 125, 125, 1);
// line-height: 39px;
// margin 49px 0 48px 85px
.introduceAll {
  display: flex;
  justify-content: space-around;
  margin: 156px 0 120px;
}

.introduceTwo {
  margin-left: 624px;
}

.introducebox {
  width: 640px;
  height: 600px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;

  img {
    width: 100%;
  }
}

.clatitle {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;

  div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 400px;
    height: 250px;

    h2 {
      text-align: center;
    }

    .clacontent {
      width: 250px;
    }
  }

  .clatit {
    font-size: 40px;
    color: #fff;
  }

  .clacontent {
    font-size: 20px;
    color: #fff;
    text-align: center;
    margin: 30px auto 40px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .more {
    width: 150px;
    height: 40px;
    background: #ffffff;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.introduceThree {
  position: absolute;
  left: 800px;
  /* background transparent */
  z-index: 0;
  width: 322px;
  height: 96px;

  p:nth-child(1) {
    font-size: 48px;
    font-family: SFUIText-Bold;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 58px;
    letter-spacing: 1px;
    text-shadow: 0px 3px 7px rgba(74, 74, 74, 0.59);
  }

  p:nth-child(2) {
    font-size: 24px;
    font-family: SFUIText-Light;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 29px;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  }
}

.Exhibition {
  padding: 0 59px 139px 59px;
}

.ExhibitionImg {
  display: flex;
  position: relative;
  justify-content: space-around;
  height: 421px;
  overflow: hidden;
  align-items: flex-end;

  div {
    width: 377px;
    height: 267px;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
}

.ExhibitionImg .EImgChange {
  text-align: center;
  overflow: visible;
  position: relative;
  height: 421px;
  width: 595px;
  bottom: 0;
  left: 0;
  animation: dropdown 0.3s linear;
  background: linear-gradient(270deg, rgba(229, 229, 231, 1) 0%, rgba(240, 241, 243, 1) 100%);
  box-shadow: 0px 2px 8px 0px rgba(215, 215, 215, 1);

  .eimgchangeimg {
    height: 100%;
    width: auto;
    margin: 0 auto;
  }
}

@keyframes dropdown {
  0% {
    height: 267px;
    width: 377px;
  }

  100% {
    height: 421px;
    width: 595px;
  }
}

.eimgchangeimg {
  height: auto;
  width: 100%;
}

.ExhibitionNve {
  text-align: center;
  margin-top: 40px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    width: 26px;
    height: 26px;
    font-size: 20px;
    font-family: SFUIText-Medium;
    font-weight: 500;
    color: rgba(155, 155, 155, 1);
    line-height: 24px;
    margin: 0 10px;
    display: inline-block;
    cursor: pointer;
  }
}

.ExhibitionNve {
  .ENveChange {
    display: inline-block;
    width: 68px;
    height: 68px;
    font-size: 36px;
    font-family: SFUIText-Medium;
    font-weight: 500;
    color: rgba(74, 74, 74, 1);
    line-height: 68px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 8px 6px 0px rgba(153, 153, 153, 0.34);
    border-radius: 50%;
  }
}

.Story {
  text-align: center;

  h1 {
    margin-bottom: 8px;
  }

  .Storyp {
    font-size: 24px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(155, 155, 155, 1);
    line-height: 33px;
    margin-bottom: 55px;
  }

  .StoryMore {
    display: flex;
    justify-content: space-around;

    .StoryDiv {
      width: 394px;

      div {
        width: 419px;
        height: 157px;
        text-align: center;
        line-height: 157px;
      }

      p {
        &:nth-child(2) {
          height: 33px;
          font-size: 24px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          color: rgba(127, 127, 127, 1);
          margin: 29px 0 29px 0;
          line-height: 33px;
        }

        &:nth-child(3) {
          font-size: 20px;
          font-family: PingFang-SC-Medium;
          font-weight: 500;
          color: rgba(155, 155, 155, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue